/* HBCU school list — 101 institutions in 22 states/territories.
   Source: HBCU_Outreach_Directory.xlsx (September 2026 working list). */
window.HBCU_SCHOOLS = [
  {
    "state": "Alabama",
    "schools": [
      "Alabama A&M University",
      "Alabama State University",
      "Bishop State Community College",
      "Gadsden State Community College",
      "J.F. Drake State Community & Technical College",
      "Lawson State Community College",
      "Miles College",
      "Oakwood University",
      "Selma University",
      "Stillman College",
      "Talladega College",
      "Trenholm State Community College",
      "Tuskegee University"
    ]
  },
  {
    "state": "Arkansas",
    "schools": [
      "Arkansas Baptist College",
      "Philander Smith University",
      "Shorter College",
      "University of Arkansas at Pine Bluff"
    ]
  },
  {
    "state": "California",
    "schools": [
      "Charles R. Drew University of Medicine and Science"
    ]
  },
  {
    "state": "Delaware",
    "schools": [
      "Delaware State University"
    ]
  },
  {
    "state": "District of Columbia",
    "schools": [
      "Howard University",
      "University of the District of Columbia"
    ]
  },
  {
    "state": "Florida",
    "schools": [
      "Bethune-Cookman University",
      "Edward Waters University",
      "Florida A&M University",
      "Florida Memorial University"
    ]
  },
  {
    "state": "Georgia",
    "schools": [
      "Albany State University",
      "Clark Atlanta University",
      "Fort Valley State University",
      "Interdenominational Theological Center",
      "Morehouse College",
      "Morehouse School of Medicine",
      "Morris Brown College",
      "Paine College",
      "Savannah State University",
      "Spelman College"
    ]
  },
  {
    "state": "Kentucky",
    "schools": [
      "Kentucky State University",
      "Simmons College of Kentucky"
    ]
  },
  {
    "state": "Louisiana",
    "schools": [
      "Dillard University",
      "Grambling State University",
      "Southern University and A&M College",
      "Southern University at New Orleans",
      "Southern University at Shreveport",
      "Xavier University of Louisiana"
    ]
  },
  {
    "state": "Maryland",
    "schools": [
      "Bowie State University",
      "Coppin State University",
      "Morgan State University",
      "University of Maryland Eastern Shore"
    ]
  },
  {
    "state": "Mississippi",
    "schools": [
      "Alcorn State University",
      "Coahoma Community College",
      "Hinds Community College, Utica campus",
      "Jackson State University",
      "Mississippi Valley State University",
      "Rust College",
      "Tougaloo College"
    ]
  },
  {
    "state": "Missouri",
    "schools": [
      "Harris-Stowe State University",
      "Lincoln University (Missouri)"
    ]
  },
  {
    "state": "North Carolina",
    "schools": [
      "Bennett College",
      "Elizabeth City State University",
      "Fayetteville State University",
      "Johnson C. Smith University",
      "Livingstone College",
      "North Carolina A&T State University",
      "North Carolina Central University",
      "Saint Augustine's University",
      "Shaw University",
      "Winston-Salem State University"
    ]
  },
  {
    "state": "Ohio",
    "schools": [
      "Central State University",
      "Wilberforce University"
    ]
  },
  {
    "state": "Oklahoma",
    "schools": [
      "Langston University"
    ]
  },
  {
    "state": "Pennsylvania",
    "schools": [
      "Cheyney University of Pennsylvania",
      "Lincoln University (Pennsylvania)"
    ]
  },
  {
    "state": "South Carolina",
    "schools": [
      "Allen University",
      "Benedict College",
      "Claflin University",
      "Clinton College",
      "Denmark Technical College",
      "Morris College",
      "South Carolina State University",
      "Voorhees University"
    ]
  },
  {
    "state": "Tennessee",
    "schools": [
      "American Baptist College",
      "Fisk University",
      "Lane College",
      "LeMoyne-Owen College",
      "Meharry Medical College",
      "Tennessee State University"
    ]
  },
  {
    "state": "Texas",
    "schools": [
      "Huston-Tillotson University",
      "Jarvis Christian University",
      "Paul Quinn College",
      "Prairie View A&M University",
      "St. Philip's College",
      "Texas College",
      "Texas Southern University",
      "Wiley University"
    ]
  },
  {
    "state": "U.S. Virgin Islands",
    "schools": [
      "University of the Virgin Islands"
    ]
  },
  {
    "state": "Virginia",
    "schools": [
      "Hampton University",
      "Norfolk State University",
      "Virginia State University",
      "Virginia Union University",
      "Virginia University of Lynchburg"
    ]
  },
  {
    "state": "West Virginia",
    "schools": [
      "Bluefield State University",
      "West Virginia State University"
    ]
  }
];
